<i [ngClass]="'icon-widget-si-'+ icon"></i>